const INVALID_COPY: Record<string, string> = {
  'corrupt-pdf': 'The PDF file appears corrupted. Please upload a working copy.',
  'encrypted-pdf': 'This PDF is password-protected. Please upload an unencrypted copy.',
  'no-pages': 'The PDF parsed successfully but contains no pages.',
  'corrupt-image': 'The image file could not be decoded. Please upload a working copy.',
};

interface InvalidFileAlertProps {
  invalidReason?: string | null;
  errorMessage?: string | null;
}

export function InvalidFileAlert({ invalidReason, errorMessage }: InvalidFileAlertProps) {
  const message =
    (invalidReason && INVALID_COPY[invalidReason]) ??
    'The uploaded file could not be processed. Please re-upload.';

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-3 sm:p-4 flex items-start gap-3">
      <div className="w-2 h-2 mt-2 rounded-full bg-amber-500 dark:bg-amber-400 shrink-0" />
      <div className="flex-1">
        <h3 className="text-sm font-medium text-amber-900 dark:text-amber-100">
          This file could not be processed
        </h3>
        <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">{message}</p>
        {errorMessage && (
          <p className="mt-2 text-xs text-amber-700 dark:text-amber-300 font-mono">{errorMessage}</p>
        )}
      </div>
    </div>
  );
}
